import { render, staticRenderFns } from "./TopReviews.vue?vue&type=template&id=6f28d6d1&scoped=true&"
import script from "./TopReviews.vue?vue&type=script&lang=js&"
export * from "./TopReviews.vue?vue&type=script&lang=js&"
import style0 from "./TopReviews.vue?vue&type=style&index=0&id=6f28d6d1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f28d6d1",
  null
  
)

export default component.exports